import { render, staticRenderFns } from "./AgendaCittadino.vue?vue&type=template&id=4c4fec23&"
import script from "./AgendaCittadino.vue?vue&type=script&lang=js&"
export * from "./AgendaCittadino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports